<div
  #chartContainer
  class="w-full h-full relative chart-container-class overflow-hidden"
></div>
